import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "real-time-player__inner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "real-time-player__ttl" }, [
  /*#__PURE__*/_createTextVNode(" 自動更新"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", { class: "real-time-player__ttl_sub" }, "（常時観測交通量）")
], -1)
const _hoisted_3 = { class: "real-time-player__btns" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { PopupWindow, ToggleButton } from "../";
import { withDefaults, ref } from "vue";

interface Props {
  modifires?: typeModifires;
  text?: {
    play?: string;
    stop?: string;
  };
  isPlaying?: boolean;
  isOpen?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'real-time-player',
  props: {
    modifires: { type: [String, Array, Boolean] },
    text: { default: () => ({}) },
    isPlaying: { type: Boolean },
    isOpen: { type: Boolean }
  },
  emits: ["playClick", "stopClick"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * ドラッグエリアスタイル
 */
const dragStyle = ref({
  top: window.document.body.clientHeight - 126 + "px",
  left: "280px",
});

/**
 * トグルクリック処理
 */
const clickToggle = (e: Event) => {
  if (e) {
    handlePlayClick(e);
  } else {
    handleStopClick(e);
  }
};

const handlePlayClick = (e: Event) => {
  emit("playClick", e);
};

const handleStopClick = (e: Event) => {
  emit("stopClick", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopupWindow), {
    "data-html2canvas-ignore": "",
    windowId: "realTimePlayer",
    width: "227px",
    draggable: true,
    hideHeader: true,
    style: _normalizeStyle(dragStyle.value),
    isOpen: _ctx.isOpen
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(mapModifires)('real-time-player', _ctx.modifires))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ToggleButton), {
              checked: props.isPlaying,
              onToggleSwitch: clickToggle
            }, null, 8, ["checked"])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["style", "isOpen"]))
}
}

})